import { type Match, type ModuleScheduleItem } from '@common/clients/api';
import { MatchService } from '@common/clients/api/generated/sdk.gen';
import { createApiClient } from '@common/clients/request/api-client';
import type { ContextData } from '@common/defaults/ContextData';
import { optaEnabledByPlatform } from '@common/opta/optaEnabledByPlatform';

export const fetchMatch = async (
    contextData: ContextData,
    matchID: string,
    moduleScheduleItem: ModuleScheduleItem | undefined,
): Promise<Match | undefined> => {
    if (!optaEnabledByPlatform[contextData.platform.id]) {
        return undefined;
    }

    const client = createApiClient({ contextData });

    const { data } = await MatchService.getMatchDetailsMatch({
        client,
        path: {
            id: matchID,
        },
        query: {
            bookmakerID: moduleScheduleItem?.bookmaker?.id || undefined,
            secondBookmakerID: moduleScheduleItem?.secondaryBookmaker?.id || undefined,
        },
    });

    return data;
};

export const fetchMatchBySlug = async (
    contextData: ContextData,
    kickOffDate: string,
    slug: string,
    moduleScheduleItem: ModuleScheduleItem | undefined,
): Promise<Match | undefined> => {
    if (!optaEnabledByPlatform[contextData.platform.id]) {
        return undefined;
    }

    const client = createApiClient({ contextData });

    const { data } = await MatchService.getMatchDetailsBySlugMatch({
        client,
        path: {
            kickOffDate,
            slug,
        },
        query: {
            bookmakerID: moduleScheduleItem?.bookmaker?.id || undefined,
            secondBookmakerID: moduleScheduleItem?.secondaryBookmaker?.id || undefined,
        },
    });

    if (!data) return;

    const match: Match = {
        ...data,
        status: data.status,
        period: data.period,
    };

    return match;
};
